export default "__VITE_ASSET__C72fGXSO__"